import src from "IMAGE";
export default { src, width: 250, height: 70, blurWidth: 0, blurHeight: 0};
